import React, { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import {
    getNomineeDetailsById,
    addNomineeDetails,
    updateNomineeDetails
} from '../../../redux/slices/ProfileSlice';
import NomineeForm from './NomineeForm';
import { formatDate } from '../../../helpers/helpers';
import Loader from "../../../components/CustomLoader/Loader";
import { TITLE_TXT, GLOBAL_CONSTANTS, BTN_TXT } from '../../../constants/constants';
import ProfileDetail from '../../../components/Details/ProfileDetail';
import CustomButton from '../../../components/CustomButton/Button';
import dayjs from "dayjs";

const { Title } = Typography;

const NomineeDetails = () => {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.auth);
    const { loading, nomineeDetailsData, nomineeLoading, nomineeError } = useSelector((state) => state.profile);
    const [isEdit, setIsEdit] = useState(false);

    useEffect(() => {
        dispatch(getNomineeDetailsById(user?.orgId));
    }, [dispatch, user?.orgId]);

    const handleAddNominee = async (values) => {
        const payload = {
            orgId: user?.orgId,
            userId: user?.userId,
            relationId: values.relationship,
            dob: values.nomineeDob.format("YYYY-MM-DD"),
            name: values.nomineeName,
            phoneNumber: values.phoneNumber,
        };
        const res = await dispatch(addNomineeDetails(payload));
        if (res.payload?.statusCode === 201) {
            dispatch(getNomineeDetailsById(user.orgId));
        }
    };

    const handleEditNominee = async (values) => {
        const payload = {
            relationId: values.relationship,
            dob: values.nomineeDob.format("YYYY-MM-DD"),
            name: values.nomineeName,
            phoneNumber: values.phoneNumber,
        };
        const res = await dispatch(updateNomineeDetails(payload));
        if (res.payload?.statusCode === 200) {
            setIsEdit(false);
            dispatch(getNomineeDetailsById(user?.orgId));
        }
    };

    if (loading) return <Loader />;

    if (!nomineeDetailsData) {
        // Show Add Form
        return (
            <NomineeForm
                mode="add"
                onSubmit={handleAddNominee}
                loading={nomineeLoading}
                error={nomineeError}
            />
        );
    }

    if (isEdit) {
        // Show Edit Form
        return (
            <NomineeForm
                mode="edit"
                onSubmit={handleEditNominee}
                onBack={() => setIsEdit(false)}
                loading={nomineeLoading}
                error={nomineeError}
                initialValues={{
                    nomineeName: nomineeDetailsData?.name,
                    nomineeDob: nomineeDetailsData?.dob ? dayjs(nomineeDetailsData?.dob) : null,
                    relationship: nomineeDetailsData?.relationId,
                    phoneNumber: nomineeDetailsData?.phoneNumber
                }}
            />
        );
    }

    // Show read-only nominee view
    return (
        <div className='investor-details-container'>
            <div className='header-container'>
                <Title level={4}>{TITLE_TXT.NOM_DETS}</Title>
            </div>
            <div className="details-container">
                <ProfileDetail
                    label={GLOBAL_CONSTANTS.NOM_LEG_NAME}
                    value={nomineeDetailsData?.name}
                />
                <ProfileDetail
                    label={GLOBAL_CONSTANTS.NOM_DOB}
                    value={formatDate(nomineeDetailsData?.dob)}
                />
                <ProfileDetail
                    label={GLOBAL_CONSTANTS.RELSHIP}
                    value={nomineeDetailsData?.relationName}
                />
                <ProfileDetail
                    label={GLOBAL_CONSTANTS.PH_NUM}
                    value={nomineeDetailsData?.phoneNumber}
                />
                <CustomButton type="primary" onClick={() => setIsEdit(true)}>
                    {BTN_TXT.EDIT}
                </CustomButton>
            </div>
        </div>
    );
};

export default NomineeDetails;
